export default {
    ATRIBUIR_DOMINIO_PERFIL_NOVO_USUARIO: 'atribuirDominioPerfilNovoUsuario',
    ATIVAR_ANEXO_LICITACAO: 'ativarAnexoLicitacao',
    ATUALIZAR_LICITACAO: 'atualizarLicitacao',
    ATUALIZAR_EDITAL: 'atualizarLicitacaoEdital',
    ATUALIZAR_LOTES_ITENS: 'atualizarLotesItens',
    ATUALIZAR_PROPOSTA_ITENS: 'atualizarPropostaItens',
    ATUALIZAR_SESSAO_DOMINIO: 'atualizarSessaoDominio',
    ATUALIZAR_USUARIO: 'atualizarUsuario',
    BUSCAR_ANEXOS_LICITACAO: 'buscarAnexosLicitacao',
    BUSCAR_CANDIDATOS_COMISSAO: 'buscarCandidatosComissao',
    BUSCAR_COMISSAO_APURACAO: 'buscarComissaoApuracao',
    BUSCAR_COMISSOES_APURACAO: 'buscarComissoesApuracao',
    BUSCAR_COMISSOES_APURACAO_POR_FILTRO: 'buscarComissoesApuracaoPorFiltro',
    BUSCAR_COMISSOES_APURACAO_PAGINADO: 'buscarComissoesApuracaoPaginado',
    BUSCAR_RESPONSAVEIS_COMISSAO: 'buscarResponsaveisComissao',
    ATUALIZAR_USUARIO_COMISSAO: 'atualizarUsuarioComissao',
    BUSCAR_CONFIGURACOES_NOVO_USUARIO: 'buscarConfiguracoesNovoUsuario',
    BUSCAR_DOCUMENTOS_PROPOSTA: 'buscarDocumentosProposta',
    BUSCAR_DOCUMENTOS_REMESSA: 'buscarDocumentosRemessa',
    BUSCAR_ESCLARECIMENTOS: 'buscarEsclarecimentos',
    BUSCAR_ESCLARECIMENTOS_IMPUGNACOES_LEGADO: 'buscarEsclarecimentosImpugnacoesLegado',
    BUSCAR_FORNECEDORES_LEGADO: 'buscarFornecedoresLegado',
    BUSCAR_FORNECEDOR_ACEITE: 'buscarFornecedorAceite',
    BUSCAR_IMPUGNACOES: 'buscarImpugnacoes',
    BUSCAR_LICITACAO: 'buscarLicitacao',
    BUSCAR_LICITACAO_LEGADO: 'buscarLicitacaoLegado',
    BUSCAR_LICITACAO_PROPOSTA_ITENS: 'buscarLicitacaoPropostaItens',
    BUSCAR_LICITACOES: 'buscarLicitacoes',
    BUSCAR_LICITACOES_LEGADO: 'buscarLicitacoesLegado',
    BUSCAR_LICITACOES_FAVORITAS_FORNECEDOR: 'buscarLicitacoesFavoritasFornecedor',
    BUSCAR_LICITACOES_FORNECEDOR_ACONTECENDO_HOJE: 'buscarLicitacoesFornecedorAcontecendoHoje',
    BUSCAR_LICITACOES_FORNECEDOR_COM_PROPOSTA: 'buscarLicitacoesFornecedorComProposta',
    BUSCAR_LOTES_ITEM_POR_LICITACAO: 'buscarLotesItemPorLicitacao',
    BUSCAR_NOMES_MODELOS_EXPORTACAO: 'buscarNomesModelosExportacao',
    BUSCAR_NOMES_MODELOS_IMPORTACAO: 'buscarNomesModelosImportacao',
    BUSCAR_ORGAOS: 'buscarOrgaos',
    ATIVAR_INTEGRACAO_IPM: 'ativarIntegracaoIPM',
    IMPORTAR_PROCESSO_IPM: 'ImportarProcessoIPM',
    IMPORTAR_PROCESSO_ARQUIVO: 'ImportarProcessoArquivo',
    BUSCAR_ORGAOS_USUARIO: 'buscarOrgaosUsuario',
    BUSCAR_PLANO_ASSINATURA: 'buscarPlanoAssinatura',
    BUSCAR_PRODUTO_POR_NOME: 'buscarProdutoPorNome',
    BUSCAR_PROPOSTA_RESUMO: 'buscarPropostaResumo',
    ATUALIZAR_PROPOSTA_PRAZO: 'atualizarPropostaPrazo',
    BUSCAR_QTD_PROPOSTAS_POR_LICITACAO: 'buscarQtdPropostasPorLicitacao',
    BUSCAR_TOKEN_ACESSO_PREGAO: 'buscarTokenAcessoPregao',
    BUSCAR_URL_COMPRA_DIRETA: 'buscarUrlCompraDireta',
    BUSCAR_USUARIO: 'buscarUsuario',
    BUSCAR_USUARIO_DOMINIO_PERFIL: 'buscarUsuarioDominioPerfil',
    BUSCAR_USUARIOS: 'buscarUsuarios',
    BUSCAR_USUARIOS_INTERNOS: 'buscarUsuariosInternos',
    BUSCAR_USUARIO_LOGADO: 'buscarUsuarioLogado',
    BUSCAR_USUARIO_INTERNO: 'buscarUsuarioInterno',
    BUSCAR_LINK_EDITAR_USUARIO: 'buscarLinkEditarUsuario',
    CANCELAR_ENVIO_PROPOSTA: 'cancelarEnvioProposta',
    DESFAVORITAR_LICITACAO: 'desfavoritarLicitacao',
    ENVIAR_EMAIL_INFO_LOGIN: 'enviarEmailInfoLogin',
    ENVIAR_PROPOSTA: 'enviarProposta',
    EXPORTAR_LOTES_ITENS: 'exportarLotesItens',
    EXPORTAR_LOTES_ITENS_SGC: 'exportarLotesItensSGC',
    EXPORTAR_RESULTADO_IPM: 'exportarLotesItensIpm',
    FAVORITAR_LICITACAO: 'favoritarLicitacao',
    IMPORTAR_LOTES_ITEM_PLANILHA: 'importarLotesItemPlanilha',
    IMPORTAR_LOTES_ITEM_TXT: 'importarLotesItemTxt',
    INATIVAR_ANEXO_LICITACAO: 'inativarAnexoLicitacao',
    INATIVAR_USUARIO: 'inativarUsuario',
    INSERIR_ANEXOS_LICITACAO: 'inserirAnexosLicitacao',
    INSERIR_COMISSAO: 'inserirComissao',
    ATUALIZAR_COMISSAO: 'atualizarComissao',
    INSERIR_DOCUMENTOS_PROPOSTA: 'inserirDocumentosProposta',
    INSERIR_DOCUMENTOS_HABILITACAO: 'inserirDocumentosHabilitacao',
    INSERIR_LICITACAO: 'inserirLicitacao',
    INSERIR_MEMBRO_COMISSAO: 'inserirMembroComissao',
    INSERIR_TERMO_LICITACAO: 'inserirTermoLicitacao',
    INSERIR_USUARIO: 'inserirUsuario',
    INSERIR_RESPOSTA: 'inserirResposta',
    BUSCAR_LOTES_RECURSO_PERMITIDO: 'buscarLotesRecursoPermitido',
    BUSCAR_RECURSOS_CONTRARRAZOES: 'buscarRecursosContrarrazoes',
    INSERIR_RECURSO: 'inserirRecurso',
    INSERIR_CONTRARRAZAO: 'inserirContrarrazao',
    INSERIR_RESPOSTA_RECURSO: 'inserirRespostaRecurso',
    INSERIR_RESPOSTA_CONTRARRAZAO: 'inserirRespostaContrarrazao',
    EDITAR_RECURSO: 'editarRecurso',
    EDITAR_CONTRARRAZAO: 'editarContrarrazao',
    ENVIAR_RECURSO: 'enviarRecurso',
    ENVIAR_CONTRARRAZAO: 'enviarContrarrazao',
    DOWNLOAD_RELATORIO_RECURSO_CONTRARRAZAO: 'downloadRelatorioRecursoContrarrazao',
    PUBLICAR_LICITACAO: 'publicarLicitacao',
    ATUALIZAR_DATA_TENTATIVA_PUBLICACAO_PNCP: 'atualizarDataTentativaPublicacaoPncp',
    REFAZER_LICITACAO: 'refazerLicitacao',
    REMOVER_ANEXO_LICITACAO: 'removerAnexoLicitacao',
    REMOVER_ARQUIVO_PROPOSTA_ITEM: 'removerArquivoPropostaItem',
    REMOVER_DOCUMENTO_PROPOSTA: 'removerDocumentoProposta',
    REMOVER_LICITACAO: 'removerLicitacao',
    REMOVER_LOTES_ITEM: 'removerLotesItem',
    REMOVER_MEMBRO_COMISSAO: 'removerMembroComissao',
    ENVIAR_MAIS_BRASIL: 'enviarMaisBrasil',
    IMPRIMIR_HISTORICO_MAIS_BRASIL: 'imprimirHistoricoMaisBrasil',
    BUSCAR_UFS: 'buscarUfs',
    BUSCAR_MUNICIPIOS: 'buscarMunicipios',
    BUSCAR_ORGAO: 'buscarOrgao',
    INSERIR_ESCLARECIMENTO_IMPUGNACAO: 'inserirEsclarecimentoImpugnacao',
    EDITAR_ESCLARECIMENTO_IMPUGNACAO: 'editarEsclarecimentoImpugnacao',
    ENVIAR_ESCLARECIMENTO_IMPUGNACAO: 'enviarEsclarecimentoImpugnacao',
    UPLOAD_ARQUIVO_PROMOTE: 'uploadArquivoPromote',
    BUSCAR_RESPOSTA_ESCLARECIMENTO_IMPUGNACAO: 'buscarRespostaEsclarecimentoImpugnacao',
    BUSCAR_DADOS_ASSINATURAS_FORNECEDOR: 'buscarDadosAssinaturasFornecedor',
    BUSCAR_PLANOS_FORNECEDOR: 'buscarPlanosFornecedor',
    BUSCAR_COBRANCAS_FORNECEDOR: 'buscarCobrancasFornecedor',
    BUSCAR_PLANO_POR_ID: 'buscarPlanoPorId',
    INSERIR_ASSINATURA_FORNECEDOR: 'inserirAssinaturaFornecedor',
    BUSCAR_COBRANCAS_POR_ASSINATURA: 'buscarCobrancasPorAssinatura',
    INSERIR_CLIENTE_FOURBILLING: 'inserirClienteFourbilling',
    ATUALIZAR_ITEM_PROPOSTA: 'atualizarItemProposta',
    BUSCAR_AMPARO_LEGAL_SITUACAO: 'BuscarAmparoLegalSituacao',
    BUSCAR_PROCESSOS_DISPONIVEIS: 'BuscarProcessosDisponiveis',
    IMPORTAR_PROCESSO: 'ImportarProcesso',
    BUSCAR_PARAMETROS: 'BuscarParametros',
    EXIBIR_NO_PNCP: 'exibirNoPncp',
    DESPUBLICAR_LICITACAO: 'despublicarLicitacao',
    SUSPENDER_LICITACAO: 'suspenderLicitacao',
    BUSCAR_SETUP: 'buscarSetup',
    BUSCAR_DOCUMENTOS_LICITACAO: 'buscarDocumentosLicitacao',
    FLOWBEE: {
        ASSINAR_EM_LOTE: 'assinarEmLote',
        JUNTAR_EM_LOTE: 'juntarEmLote',
        JUNTAR_DOCUMENTO: 'juntarDocumento',
        CANCELAR_DOCUMENTO: 'cancelarDocumento',
        BAIXAR_DOCUMENTO: 'baixarDocumentoFlowbee',
        BAIXAR_ARQUIVO: 'baixarArquivo',
        BAIXAR_ARQUIVO_USUARIO_LOGADO: 'baixarArquivoUsuarioLogado',
        DESENTRANHAR_DOCUMENTO: 'desentranharDocumento',
        REORDENAR_DOCUMENTO: 'reordenarDocumento',
        BUSCAR_TODOS_DOC_JUNTADO_PROCESSO: 'buscarTodosDocsJuntadoProcesso',
        BAIXAR_DOCUMENTOS_SELECIONADOS: 'baixarDocumentosSelecionados',
        BUSCAR_CONFIGURACAO: 'buscarConfiguracao'
    },
    NOTIFICAR_DOCUMENTOS_EDITAL: 'notificarDocumentosEdital',
    REENVIAR_DOCUMENTOS_COM_ERRO_PNCP: 'reenviarDocumentosComErroPncp',
    BUSCAR_MODELOS_DESENTRANHAMENTO: 'buscarModelosDesentranhamento',
    BUSCAR_NUMERO_HASH: 'buscarNumeroHash',
    BUSCAR_PROTOCOLOS: 'buscarProtocolos',
    BUSCAR_PROTOCOLO_DETALHE: 'buscarProtocoloDetalhe',
    GERAR_RECIBO_DE_PROTOCOLO: 'gerarReciboDeProtocolo',
    EXISTE_PROPOSTA_ENVIADA: 'existePropostaEnviada',
    CRIAR_TERMO_ACEITE: 'criarTermoAceiteAction',
    ATUALIZAR_TERMO_ACEITE: 'atualizarTermoAceiteAction',
    BUSCAR_TERMOS: 'buscarTermosAction',
    BUSCAR_TERMO_ACEITE: 'buscarTermoAceiteAction',
    BUSCAR_TERMOS_ACEITE: 'buscarTermosAceiteAction',
    GERAR_TERMO_ACEITE: 'gerarTermoAceite',
    BUSCAR_SITUACAO_INTEGRACOES: 'buscarSituacaoIntegracoesAction',
    CREDENCIAMENTO: {
        BUSCAR_CREDENCIAMENTOS: 'buscarCredenciamentos',
        BUSCAR_DOCUMENTOS_CREDENCIAMENTO: 'buscarDocumentosCredenciamento',
        SOLICITACAO: {
            INSERIR_DOCUMENTOS_SOLICITACAO_CREDENCIAMENTO: 'inserirDocumentosSolicitacaoCredenciamento',
            INSERIR_NOVO_DOCUMENTO_SOLICITACAO_CREDENCIAMENTO: 'inserirNovoDocumentoSolicitacaoCredenciamento',
            REMOVER_DOCUMENTO_SOLICITACAO_CREDENCIAMENTO: 'removerDocumentoSolicitacaoCredenciamento',
            BUSCAR_DOCUMENTOS_SOLICITACAO_CREDENCIAMENTO: 'buscarDocumentosSolicitacaoCredenciamento',
            PARTICIPAR_SOLICITACAO_CREDENCIAMENTO: 'participarSolicitacaoCredenciamento',
            BUSCAR_SOLICITACAO_CREDENCIAMENTO: 'buscarSolicitacaoCredenciamento',
            CREDENCIAR: 'credenciarSolicitacao',
            NAO_CREDENCIAR: 'naoCredenciarSolicitacao',
            BUSCAR_CLASSIFICACOES_DISPONIVEIS: 'buscarClassificacoesDisponiveis',
            ATRIBUIR_CLASSIFICACAO_AO_PARTICIPANTE: 'atribuirClassificacaoAoParticipante',
            BUSCAR_RESULTADOS_SOLICITACOES_CREDENCIAMENTO: 'buscarResultadosSolicitacoesCredenciamento',
            BAIXAR_TODOS_DOCUMENTOS: 'baixarTodosDocumentosFornecedor',
            REENVIAR_DOCUMENTOS: 'reenviarDocumentos',
            SALVAR_ITENS: 'salvarItensSolicitacaoCredenciamento',
            SOLICITAR_ASSINATURA: 'solicitarAssinaturaSolicitacaoCredenciamento',
        },
        DEMANDA: {
            BUSCAR_DEMANDAS_CREDENCIAMENTO: 'buscarDemandasCredenciamento',
            BUSCAR_UNIDADES_ORGANIZACIONAIS: 'buscarUnidadesOrganizacionais',
            BUSCAR_ORGAOS_USUARIO_POR_FUNCAO: 'buscarOrgaosUsuarioPorFuncao',
            BUSCAR_CREDENCIADOS: 'buscarCredenciados',
            BUSCAR_ITENS_CREDENCIAMENTO: 'buscarItensCredenciamento',
            ADICIONAR_NOVA_DEMANDA: 'adicionarNovaDemanda',
            BUSCAR_ITENS_POR_DEMANDA: 'buscarItensPorDemanda',
            EDITAR_CANCELAR_DEMANDA: 'editarCancelarDemanda',
            BUSCAR_DEMANDA_POR_ID: 'buscarDemandaCredenciamentoPorId',
            EXPORTAR_DEMANDA_PARA_CONTRATOS: 'exportarDemandaParaContratos',
            BUSCAR_DOCUMENTOS_CONTRATACAO: 'buscarDocumentosContratacao',
            SALVAR_DOC_DEMANDAS_CREDENCIAMENTO: 'salvarDocDemandaCredenciamento',
        },
        ANALISE_SOLICITACAO_CREDENCIAMENTO: {
            INSERIR_ANALISE_SOLICITACAO_CREDENCIAMENTO: 'inserirAnaliseSolicitacaoCredenciamento',
            BUSCAR_ANALISE_SOLICITACAO_CREDENCIAMENTO_EM_ANALISE: 'buscarAnaliseSolicitacaoCredenciamentoEmAnalise',
            FINALIZAR_ANALISE_SOLICITACAO_CREDENCIAMENTO: 'finalizarAnaliseSolicitacaoCredenciamento',
            BUSCAR_RELATORIOS_ANALISES_SOLICITACOES_CREDENCIAMENTO: 'buscarRelatoriosAnalisesSolicitacoesCredenciamento',
            BUSCAR_DOCUMENTOS_ANALISE_SOLICITACAO_CREDENCIAMENTO: 'buscarDocumentosAnaliseSolicitacaoCredenciamento',
            ATUALIZAR_ANALISE_DE_DOCUMENTO_SELECIONADO: 'atualizarAnaliseDeDocumentoSelecionado',
            BUSCAR_DADOS_CABECALHO_CREDENCIAMENTO: 'buscarDadosCabecalhoCredenciamento',
            BUSCAR_DETALHE_ITENS_FORNECEDOR: 'buscarDetalheItensFornecedor',
        },
        BAIXAR_DOCUMENTO: 'baixarDocumentoCredenciamento',
        ALTERAR_SITUACAO_DOCUMENTO_CREDENCIAMENTO: 'alterarSituacaoDocumentoCredenciamento',
        REMOVER_CREDENCIAMENTO: 'removerCredenciamento',
        BUSCAR_LOTES_CRDENCIAMENTO: 'buscarLotesCredenciamento',
        CANCELAR_PARTICIPACAO_LOTES_CRDENCIAMENTO: 'cancelarParticipacaoLoteCredenciamento',
        BUSCAR_INFORMACOES_USUARIO: 'buscarInformacoesUsuario',
        DOCUMENTO: {
            ASSINAR_ELETRONICAMENTE: 'assinarEletronicamenteCredenciamento',
            ENVIAR_PNCP: 'enviarDocumentoCredenciamentoPncp',
            REMOVER_PNCP: 'removerDocumentoCredenciamentoPncp',
        },
        DESPUBLICAR_CREDENCIAMENTO: 'despublicarCredenciamento',
        ALTERAR_DATA_FIM_CREDENCIAMENTO: 'alterarDataFimCredenciamento',
    },
    BUSCAR_LINHAS_FORNECIMENTO_EXTERNAS: 'buscarLinhasFornecimentoExternas',
    BUSCAR_LINHAS_FORNECIMENTO: 'buscarLinhasFornecimento',
    ADICIONAR_LINHA_FORNECIMENTO: 'adicionarLinhaFornecimento',
    REMOVER_LINHA_FORNECIMENTO: 'removerLinhaFornecimento',
    ATUALIZAR_DADOS_SGC: 'atualizarDadosSgc',
    BUSCAR_MOEDAS_DISPONIVEIS_PREGAO_FORNECEDOR: 'buscarMoedasDisponiveisPregaoFornecedor',
    BUSCAR_MOEDA_SELECIONADA_FORNECEDOR: 'buscarMoedaSelecionadaPeloFornecedor',
    BAIXAR_RELATORIO_DOWNLOAD_EDITAL: 'baixarRelatorioDownloadEdital',
    BUSCAR_RELATORIOS_READEQUACAO_PROPOSTA: 'buscarRelatoriosReadequacaoProposta',
    BUSCAR_PROPOSTAS_FORNECEDOR: 'buscarPropostasFornecedor',
    SALVAR_ITENS_READEQUADOS: 'salvarItensReadequados',
    ENVIAR_PROPOSTAS_READEQUADAS: 'enviarPropostasReadequadas',
    DESINSCREVER_FORNECEDOR_EMAILS_LICITACAO: 'desinscreverFornecedorEmailsLicitacao',
    BUSCAR_LICITACAO_RETORNAR: 'buscarLicitacaoRetornar',
    GERAR_ATA_USIGA: 'gerarAtaUsiga',
    BUSCAR_LOTES_PREGAO_USIGA: 'buscarLotesPregaoUsiga',
    DOWNLOAD_ANEXO_USIGA: 'downloadAnexoUsiga',
    BUSCAR_DOCUMENTOS_FORNECEDORES_USIGA: 'buscarDocumentosFornecedoresUsiga',
    DOWNLOAD_ANEXO_DOC_FORNECEDOR: 'downloadAnexoDocFornecedorUsiga',
    BUSCAR_MODALIDADES: 'buscarModalidades',
    BUSCAR_CATEGORIAS: 'buscarCategorias',
    BUSCAR_ESPECIFICACOES_RAMO: 'buscarEspecificoesRamo',
    EXCLUIR_PREPUBLICACAO: 'excluirPrepublicacao',
    NOVA_PREPUBLICACAO: 'novaPrePublicacao',
    BUSCAR_PROCOTOLO: 'buscarProtocoloEsfinge',
    EXCLUIR_OCORRENCIA: 'excluirOcorrencia',
    INSERIR_OCORRENCIA: 'inserirOcorrenciaEsfinge',
    ALTERAR_OCORRENCIA: 'alterarOcorrenciaEsfinge',
    BUSCAR_LOTES_DESERTO_FRACASSADO_OCORRENCIA: 'buscarLotesDesertoFracassadoOcorrenciaEsfinge',
    BUSCAR_HISTORICOS_OCORRENCIA: 'buscarHistoricosOcorrenciaEsfinge',
    MANUTENCAO: {
        ATUALIZAR_PERMISSOES_FORNECEDOR: 'atualizarPermissoesFornecedor'
    },
    BUSCAR_USUARIOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO: 'buscarUsuariosParaResponderEsclarecimentoImpugnacao',
    CONVIDAR_USUARIO_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO: 'convidarUsuarioParaResponderEsclarecimentoImpugnacao',
    BUSCAR_USUARIOS_CONVIDADOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO: 'buscarUsuariosConvidadosParaResponderEsclarecimentoImpugnacao',
    BUSCAR_ESCLARECIMENTOS_USUARIO_CONVIDADO: 'buscarEsclarecimentosUsuarioConvidado',
    INSERIR_ESCLARECIMENTO_IMPUGNACAO_SERVIDOR: 'inserirEsclarecimentoImpugnacaoServidor',
    BUSCAR_IMAGENS_ITEM_BASE64: 'buscarImagensItemBase64',
    EXCLUIR_IMAGEM_ITEM: 'excluirImagemItem',
    INSERIR_IMAGENS_ITEM: 'inserirImagemItem',
    VERIFICAR_PERMISSAO_ORGAO: 'verificarPermissaoOrgao',
    BUSCAR_PROTOCOLOS_FORNECEDOR: 'buscarProtocolosFornecedor'
}
